import { Controller } from '@hotwired/stimulus'

export default class SubscriptionController extends Controller {
  static targets = ['maxAmountMessageContainer', 'amount'];
  static values = {
    maxAmount: Number,
  }

  connect() {}

  checkMaxAmount() {
    if (this.amountTarget.value > this.maxAmountValue) {
      this.maxAmountMessageContainerTarget.classList.remove('d-none');
    } else {
      this.maxAmountMessageContainerTarget.classList.add('d-none');
    }
  }

  closeOffcanvas() {
    if (this.amountTarget.value > 0) {
      bootstrap.Offcanvas.getOrCreateInstance(this.element).hide();
    }
  }
}
